import { StarsIcon as e } from "../../../icons/stars-icon.mjs";
import "react";
import { Button as t } from "@systemeio/components";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/modules/widget/components/ai-chat-button.tsx
var i = ({ className: i, onClick: a, disabled: o }) => /* @__PURE__ */ r(t, {
	variant: "ghost-color",
	size: "sm",
	className: i,
	onClick: a,
	disabled: o,
	children: [/* @__PURE__ */ n(e, { viewBox: "2 2 20 20" }), "AI Chat"]
});
//#endregion
export { i as AiChatButton };
